import { Check, CheckCheck, Loader2, AlertCircle } from 'lucide-react';

// Format read time for display (e.g., "Read at 3:45 PM")
const formatReadTime = (timestamp) => {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday = date.toDateString() === yesterday.toDateString();
  
  const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  
  if (isToday) {
    return `Read ${timeStr}`;
  } else if (isYesterday) {
    return `Read yesterday ${timeStr}`;
  } else {
    return `Read ${date.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${timeStr}`;
  }
};

// Message status icons with labels and timestamps
const MessageStatus = ({ status, readAt, deliveredAt }) => {
  switch (status) {
    case 'sending':
      return (
        <span className="flex items-center gap-1">
          <Loader2 className="h-3 w-3 animate-spin text-gray-400" />
        </span>
      );
    case 'sent':
      return (
        <span className="flex items-center gap-1">
          <Check className="h-3 w-3 text-gray-400" />
          <span className="text-[10px] text-gray-400">Sent</span>
        </span>
      );
    case 'delivered':
      return (
        <span className="flex items-center gap-1">
          <CheckCheck className="h-3 w-3 text-gray-400" />
          <span className="text-[10px] text-gray-400">Delivered</span>
        </span>
      );
    case 'read':
      const readTimeStr = formatReadTime(readAt);
      return (
        <span className="flex items-center gap-1">
          <CheckCheck className="h-3 w-3 text-blue-400" />
          <span className="text-[10px] text-blue-400" title={readAt ? new Date(readAt).toLocaleString() : ''}>
            {readTimeStr || 'Read'}
          </span>
        </span>
      );
    case 'failed':
      return (
        <span className="flex items-center gap-1">
          <AlertCircle className="h-3 w-3 text-red-400" />
          <span className="text-[10px] text-red-400">Failed</span>
        </span>
      );
    default:
      return (
        <span className="flex items-center gap-1">
          <Check className="h-3 w-3 text-gray-400" />
        </span>
      );
  }
};

export default MessageStatus;
export { formatReadTime };
